var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51196 1.5L1.50633 9.65644C1.394 9.78848 1.36869 9.97378 1.44149 10.1311C1.5143 10.2884 1.67194 10.3891 1.8453 10.3889H4.95641V17.5L11.9609 9.34356C12.073 9.21168 12.0984 9.02666 12.0259 8.86943C11.9534 8.7122 11.7962 8.61139 11.6231 8.61111H8.51196V1.5Z",
    fill: "#FBEC66",
    stroke: "#1E2734",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashIcon);
export default __webpack_public_path__ + "static/media/flashIcon.6a71f107b2b2e8bf9763f6f8f76d414c.svg";
export { ForwardRef as ReactComponent };